import { useCallback, useMemo, useRef, useState } from 'react';
import I18N from '@leverege/i18n';
import useObjectKeysMemoize from './useObjectKeysMemoize.js';
import { defaultOnIdentityProviderClick } from '../Util.js';
import { EMPTY_OBJ, LoginDefaultProps } from '../Constants.js';
const {
  t
} = I18N.ns('login.Login');
export default function useLogin(opts) {
  const {
    classNames = EMPTY_OBJ,
    variants: pVariants,
    options: pOptions,
    components: pComponents,
    onLogin,
    onIdentityProviderClick = defaultOnIdentityProviderClick,
    onLoginByCodeClick,
    onForgotPasswordClick,
    onAfterLogin,
    onLoginError,
    userCode,
    showIdentityProviders = true,
    loginByCodeIcon = t('iconLoginByCode'),
    requestDeviceCodeIcon = t('iconRequestDeviceCode'),
    ...restProps
  } = opts;
  const v = useObjectKeysMemoize(pVariants);
  const variants = useMemo(() => {
    return {
      ...LoginDefaultProps.variants,
      ...v
    };
  }, [v]);
  const o = useObjectKeysMemoize(pOptions);
  const options = useMemo(() => {
    return {
      ...LoginDefaultProps.options,
      ...o
    };
  }, [o]);
  const c = useObjectKeysMemoize(pComponents);
  const components = useMemo(() => {
    return {
      ...LoginDefaultProps.components,
      ...c
    };
  }, [c]);
  const rest = useObjectKeysMemoize(restProps);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const userRef = useRef();
  const passwordRef = useRef();
  const onSubmit = useCallback(({
    // Fix for chrome auto-fill bug
    username = userRef.current?.value,
    password = passwordRef.current?.value
  }) => {
    setLoading(true);
    setError(null);
    const prom = onLogin?.(username.trim(), password, userCode);
    if (prom?.then) {
      prom.then(res => {
        return onAfterLogin?.(res);
      }).catch(err => {
        setError(err);
        onLoginError?.(err);
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, [onLogin, onLoginError, onAfterLogin, userCode]);
  return useMemo(() => {
    return {
      variants,
      classNames,
      options,
      components,
      state: {
        error,
        loading,
        onSubmit
      },
      ...rest,
      onLogin,
      onIdentityProviderClick,
      onLoginByCodeClick,
      onForgotPasswordClick,
      userRef,
      passwordRef,
      showIdentityProviders,
      loginByCodeIcon,
      requestDeviceCodeIcon
    };
  }, [classNames, components, error, loading, onForgotPasswordClick, onIdentityProviderClick, onLogin, onLoginByCodeClick, onSubmit, options, passwordRef, rest, userRef, variants, showIdentityProviders, loginByCodeIcon, requestDeviceCodeIcon]);
}